// React
import React, { FC, useEffect } from 'react';

// Libraries
import { useRecoilState } from 'recoil';

// Material
import { TextField, InputAdornment, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// Common styles
import { WrapperSearch } from 'styles';

// Recoil
import { searchInputValueAtom } from 'recoil/ValueSearchRecoil';
import { paramsGetListAtom } from 'recoil/ParamsGetListRecoil';

// Utils
import { ParamsGetListSetting } from 'utils/constants';

// Component
const SearchInput: FC = () => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useRecoilState(searchInputValueAtom);
  const [paramsGetUser, setParamsGetUser] = useRecoilState(paramsGetListAtom);

  const handleSearch = () => {
    if (searchQuery !== (paramsGetUser.keyword ?? '')) {
      setParamsGetUser(() => ({
        ...paramsGetUser,
        page: ParamsGetListSetting.DEFAULT_PAGE as number,
        keyword: searchQuery.toString(),
      }));
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    setSearchQuery(paramsGetUser.keyword ?? '');
  }, [paramsGetUser.keyword]);

  return (
    <WrapperSearch>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="検索"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value.trimStart())}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" onClick={handleSearch}>
              <SearchIcon
                sx={{
                  width: '36px',
                  height: '36px',
                  color: '#000000',
                  cursor: 'pointer',
                  [theme.breakpoints.down('sm')]: {
                    width: '28px',
                    height: '28px',
                  },
                }}
              />
            </InputAdornment>
          ),
          sx: {
            height: '58px',
            [theme.breakpoints.down('sm')]: {
              height: '48px',
            },
          },
        }}
        sx={{
          '& .MuiOutlinedInput-input': {
            padding: '12px 33px',
          },
        }}
      />
    </WrapperSearch>
  );
};

export default SearchInput;
